'use client'

import { useMemo } from 'react'

import type {
  ServiceMapTimeRangeFilterLabels,
  ServiceMapTimeRangeFilterOption,
} from '../components/TimeRangeFilter/time-range.types'
import { DEFAULT_TIME_RANGE_VALUE, SERVICE_MAP_TIME_RANGE_VALUES, TIME_RANGE_CUSTOM_VALUE } from '../service-map.const'
import type { ServiceMapTimeRangeFilterValue } from '../service-map.interface'

const DEFAULT_LABELS: ServiceMapTimeRangeFilterLabels = {
  title: 'Time range',
  cancel: 'Cancel',
  apply: 'Apply',
  startDate: 'Start date',
  endDate: 'End date',
  startTime: 'Start time',
  endTime: 'End time',
  triggerCustomFallback: 'Custom range',
}

const DEFAULT_OPTIONS: readonly ServiceMapTimeRangeFilterOption[] = [
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last30Min, label: 'Last 30 min' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.lastHour, label: 'Last hour' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last4Hour, label: 'Last 4 hours' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last12Hour, label: 'Last 12 hours' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last24Hour, label: 'Last 24 hours' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last48Hours, label: 'Last 48 hours' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last3Days, label: 'Last 3 days' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last7Days, label: 'Last 7 days' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.last30Days, label: 'Last 30 days' },
  { value: SERVICE_MAP_TIME_RANGE_VALUES.custom, label: 'Custom' },
]

export type GatewayTimeRangeFilterUiConfig = {
  options: readonly ServiceMapTimeRangeFilterOption[]
  labels: ServiceMapTimeRangeFilterLabels
  defaultValue: ServiceMapTimeRangeFilterValue
  customValue: typeof TIME_RANGE_CUSTOM_VALUE
}

export function useGatewayTimeRangeFilterUiConfig(
  labels?: Partial<ServiceMapTimeRangeFilterLabels>,
  options?: readonly ServiceMapTimeRangeFilterOption[]
): GatewayTimeRangeFilterUiConfig {
  return useMemo(
    () => ({
      options: options ?? DEFAULT_OPTIONS,
      labels: { ...DEFAULT_LABELS, ...labels },
      defaultValue: DEFAULT_TIME_RANGE_VALUE,
      customValue: TIME_RANGE_CUSTOM_VALUE,
    }),
    [labels, options]
  )
}
